import { camelCaseToSnakeCaseString, snakeCaseToCamelCaseString } from '@/utils/stringCase'

function transformKeys(keyTransformer, data) {
  if (data === null) {
    return null
  } else if (data instanceof Array) {
    return data.map(item => transformKeys(keyTransformer, item))
  } else if (typeof data === 'object') {
    let newData = {}
    Object.keys(data).forEach(key => {
      newData[keyTransformer(key)] = transformKeys(keyTransformer, data[key])
    })
    return newData
  } else {
    return data
  }
}

export function snakeCaseToCamelCase(data) {
  return transformKeys(snakeCaseToCamelCaseString, data)
}

export function camelCaseToSnakeCase(data) {
  return transformKeys(camelCaseToSnakeCaseString, data)
}
